import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { changeEnter } from 'src/utils/changeEnter';

const ShortAnswerSurvey_0201: FC = () => {
  let currentIndex = useSelector(
    (state: any) => state.imageUpload.currentIndex
  );
  let text = useSelector((state: RootState) => state.editText.text);
  let btnText = useSelector((state: RootState) => state.buttons.btnText);

  return (
    <>
      <div className="root_view root_view_0201">
        <div className="template">
          <div className="center_horizon top_wrapper">
            <div></div>
            <button className="close_btn"></button>
          </div>
          <div className="center_wrapper">
            <div className="title">
              <div className="title_inner">
                {changeEnter(text?.title_0201?.[currentIndex])}
              </div>
            </div>
            <div className="logo">
              <button></button>
            </div>
            <div className="sub_title">
              <div className="sub_title_inner">
                {changeEnter(text?.sub_title_0201?.[currentIndex])}
              </div>
            </div>
          </div>
          <div className="center_horizon bottom">
            <button className="button">
              {btnText?.button_0201?.[currentIndex]}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default ShortAnswerSurvey_0201;
